import {
  SportsEsports,
  Movie,
  Weekend,
  Gesture,
  ChildFriendly,
  Fastfood,
  SportsMotorsports,
} from '@material-ui/icons';

export const items = [
  {
    image: window.location.origin + '/img/dev/amazonish.jpg',
    link: 'https://amazon-clone-phaxz10.vercel.app/',
    title: 'Amazon Clone',
    description:
      'eCommerce web app. Using React.js(Next.js) for the front-end and Stripe for payment integration. Built to showcase my skills in Next.js, Redux, Redux-persist, Responsive Design and REST API Integration.',
    slug: 'amazon-ish',
    category: 'code',
  },
  {
    image: window.location.origin + '/img/dev/fakebook.jpg',
    link: 'https://fakebook-seven.vercel.app/',
    title: 'Facebook Clone',
    description:
      'Social media app built using Next.js framework, Tailwind for responsive design, and Google Firestore for database. This app features file upload, Realtime post update and Realtime Chat.',
    slug: 'fakebook',
    category: 'code',
  },
  {
    image: window.location.origin + '/img/dev/slackish.jpg',
    link: 'https://slack-clone-70fb1.web.app/',
    title: 'Slack Clone',
    description:
      'Simple realtime chat app with React.js front-end and Firestore as database',
    slug: 'slack-ish',
    category: 'code',
  },
  {
    image: window.location.origin + '/img/dev/netflixish.jpg',
    link: 'https://netflix-clone-42b7c.web.app/',
    title: 'Netflix Clone',
    description:
      'Netflix clone is a video service app that plays movie trailers built with React.js and TMDB API for the data.',
    slug: 'netflix-ish',
    category: 'code',
  },
];

export const skills = [
  { skill: 'CSS', profeciency: 80 },
  { skill: 'HTML', profeciency: 95 },
  { skill: 'JavaScript', profeciency: 80 },
  { skill: 'React.js', profeciency: 75 },
  { skill: 'Next.js', profeciency: 75 },
  { skill: 'Gatsby.js', profeciency: 50 },
  { skill: 'Node.js', profeciency: 50 },
  { skill: 'UI Design', profeciency: 85 },
  { skill: 'Photoshop', profeciency: 95 },
  { skill: 'Sketch', profeciency: 90 },
];

export const hobbies = [
  { icon: <SportsEsports />, caption: 'Playing Video Games' },
  { icon: <Movie />, caption: 'Watching Stuff' },
  { icon: <Weekend />, caption: 'Just Relaxing' },
  { icon: <Gesture />, caption: 'Drawing Stuff' },
  { icon: <ChildFriendly />, caption: 'Doing daddy things' },
  { icon: <Fastfood />, caption: 'Eating...' },
  { icon: <SportsMotorsports />, caption: 'Motorcycle Riding' },
];
